<template>
  <!-- Sidebar -->
  <div class="min-h-screen bg-gray-800 min-w-min text-center">
    <div class="relative h-full">
      <div class="xl:py-2 pt-16">
        <h1 class="font-bold text-gray-300 mb-3">{{ title }}</h1>
        <!-- Title -->
        <!-- Buttons -->
        <div
          v-for="el in items"
          class="
                  block
                  xl:flex
                  xl:items-center
                  xl:text-left
                  shadow-light
                  xl:shadow-none
                  py-6
                  lg:py-2
                  lg:px-4
                  border-l-4
                  hover:bg-orange-700
                  transition duration-150 ease-in-out
                "
          v-on:click="select(el)"
          v-bind:key="el.id"
          v-bind:class="[
            el === currentEl ? 'bg-orange-600 ' : 'border-transparent',
          ]"
        >
          <a class="text-white text-base font-semibold" href="#">{{ el }}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .sidebar-height{
    height: calc(100vh - 112px);
  }
</style>

<script>
export default {
  name: 'Sidebar',
  props: ['title', 'items', 'parentHandler', 'icons'],
  mounted() {
    this.currentEl = this.items[0];
    this.currentIcons = this.icons;
    console.log('Current element: ', this.currentEl);
  },
  watch: {
    items: {
      immediate: true,
      handler() {
        this.currentEl = this.items[0];
        if (typeof this.currentEl !== 'undefined') {
          this.parentHandler(this.items[0]);
        }
      },
    },
  },
  methods: {
    select: function(el) {
      this.currentEl = el;
      this.parentHandler(el);
    },
  },
  data: function() {
    return {
      currentEl: '',
    };
  },
};
</script>
